import { render, staticRenderFns } from "./video-monitor.vue?vue&type=template&id=348d9e8b&"
import script from "./video-monitor.vue?vue&type=script&lang=js&"
export * from "./video-monitor.vue?vue&type=script&lang=js&"
import style0 from "./video-monitor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports